// @Version: 1.0.1
import { Injectable, signal, WritableSignal } from '@angular/core';
import { TRANSLATE_PATH } from '../../shared.model';

export interface IShowSpinner {
   [key:number]: boolean; 
}

@Injectable({
   providedIn: 'root'
})
export class NoMobileService {
   public TRANSLATE_PATH: typeof TRANSLATE_PATH = TRANSLATE_PATH;
   
   public noMobile$$: WritableSignal<string> = signal(TRANSLATE_PATH.BLANK_NOMOBILE_ENABLED);

   set noMobile (val: string) {
      this.noMobile$$.set(val); 
   }

   constructor () { 
   }
}
